import {getAppraisersTrue} from '../../../services/adminService'
import {adminListActions} from '../admin'

const getAppraiserTrueAction = (payload) => {
  return (dispatch) => {
    dispatch(adminListActions.getAppraiserTrueRequest())
    getAppraisersTrue(payload).then((res) => {
      dispatch(adminListActions.getAppraiserTrueSuccess(res))
    }).catch((error) => {
      dispatch(adminListActions.getAppraiserTrueFailure(error))
    })

  }
}

export default getAppraiserTrueAction
